import { useState, useEffect } from 'react'

interface UseDelayOptions {
  delay?: number
  onComplete?: () => void
}

export function useDelay(options: UseDelayOptions = {}) {
  const { delay = 500, onComplete } = options
  const [show, setShow] = useState(false)

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShow(true)
      onComplete?.()
    }, delay)

    return () => clearTimeout(timeoutId)
  }, [delay, onComplete])

  return show
}
